import { render, staticRenderFns } from "./ForwardMessage.vue?vue&type=template&id=f340fac6&"
import script from "./ForwardMessage.vue?vue&type=script&lang=js&"
export * from "./ForwardMessage.vue?vue&type=script&lang=js&"
import style0 from "./ForwardMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports